// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4112":"a3ede44e6a0beb25","5540":"68424301b512e159","8437":"0b1f797e0d97a27e","8787":"a1e3a7d3afb0d21c"}[chunkId] + ".css";
};